/* @ngInject */
export default class WagesRollCtrl {
    constructor(
        $sce,
        $scope,
        $state,
        Utility,
        $timeout,
        $rootScope,
        BuildingsService,
        FinancialsService,
        LocalStorageService,
        WagesRollService,
        AuthorizationService
    ) {
        this.$sce = $sce;
        this.$scope = $scope;
        this.$state = $state;
        this.Utility = Utility;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.BuildingsService = BuildingsService;
        this.FinancialsService = FinancialsService;
        this.LocalStorageService = LocalStorageService;
        this.WagesRollService = WagesRollService;
        this.AuthorizationService = AuthorizationService;
        this.init();
        this.activate();
    }

    init() {
        this._switchIsBusyLoading(true);
        this.isFilterActive = true;
        this.filterYear = undefined;
        this.reportModelHeader = '';
        this.filterMonth = undefined;

        this.selectedBuildingRef = '';
        this.selectedBuildingName = '';
        this.investmentStatment = undefined;
        this.financialsServiceData = undefined;
        this.statusInformation = null;

        this.today = this.Utility.getFormatedDate(new Date());

        const { date } = this.$state.params;

        if (date) {
            this.selectedDate  = this.Utility.getFormatedDate(date);
        } else {
            this.selectedDate = this.Utility.getFormatedDate(new Date());
        }

        this.selectedDateYear = this.Utility.getFormatedDate(new Date());

        this.$scope.$on('selected-building-changed', async (event, newValue) => {
            await this.onSelectedBuildingChanged(this, newValue);
        });

        this.$scope.$watch(
            'wagesRollVm.filterYear',
            async (newValue, oldValue) => {
                if (newValue && newValue !== oldValue && oldValue) {
                    await this.getFinancialMonths(this.Utility.getFormatedDate(this.filterYear));
                }
            },
            true
        );
    }

    async activate() {
        this.financialsServiceData = this.FinancialsService;
        this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

        let buildingName = '';
        const userProfile = this.LocalStorageService.retrieve('userProfile');

        if (userProfile) {
            if (!this.selectedBuildingRef) {
                this.selectedBuildingRef = userProfile.BuildingProfiles[0].SchemeReference;
            }
            const selectedBuilding = userProfile.BuildingProfiles.find((building) => {
                return building.SchemeReference.toUpperCase().trim() === this.selectedBuildingRef.toUpperCase().trim();
            });

            if (selectedBuilding) {
                buildingName = selectedBuilding.SchemeName;
            }
        }

        await this.getFinancialYears(true);
        this.selectedBuildingName = buildingName;
    }

    openFinancials(page) {
        this.saveSelectedDate();
        this.$rootScope.$broadcast('navigate-changed', page, { date: this.filterMonth });
    }

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async gotoOldFinancials() {
        const date = moment(this.filterMonth).format('MMM YYYY');
        let nav = `Monthly Financial Statements>${date}`;
        nav = encodeURI(nav);
        this.$state.go('documents', { nav });
    }

    isDesktop() {
        this.LocalStorageService.save('mediaDevice', 'mobile');
        const mdvice = this.LocalStorageService.retrieve('mediaDevice');
        if (mdvice == 'mobile') {
            return true;
        }

        return false;
    }

    async filterByCurrentMonth() {
        this.isFilterActive = true;
        await this.getWagesRoll();
    }

    async filterByMonth() {
        if (this.filterMonth) {
            this.selectedDate = this.Utility.getFormatedDate(this.filterMonth);
            await this.getWagesRoll();
        }
    }

    async filterByYear() {
        await this.filterByMonth();
    }

    async getReport() {
        this.reportModelHeader = `${this.selectedBuildingName} - Wages Roll - ${moment(
            this.Utility.getFormatedDate(this.filterMonth)
        ).format('MMM YYYY')}`;

        try {
            await this.financialsServiceData.getReport(
                this.selectedBuildingRef,
                this.Utility.getFormatedDate(this.filterMonth),
                8,
                this.reportModelHeader
            );
        } catch (err) {
            console.error("Error while generating Wages' Roll");
        }
    }

    async onSelectedBuildingChanged(event, schemeRef) {
        this._switchIsBusyLoading(true);
        if (schemeRef && schemeRef['length'] > 2) this.selectedBuildingRef = schemeRef;
        else this.selectedBuildingRef = this.BuildingsService.getSelectedBuildingRef();

        if (this.selectedBuildingRef && this.selectedBuildingRef.length > 2) {
            await this.activate();
        }
    }

    async getFinancialYears(isInit) {
        this._switchIsBusyLoading(true);

        try {
            await this.financialsServiceData.getFinancialYears(this.selectedBuildingRef, this.today);
            if (isInit) {
                await this.getSelectedDate(true);
            } else {
                this.filterYear = this.financialsServiceData.financialYears[
                    this.financialsServiceData.financialYears.length - 1
                ].WhenTo;
                this.selectedDateYear = this.Utility.getFormatedDate(this.filterYear);
                await this.getFinancialMonths(this.today);
            }
        } catch (err) {
            console.error('Error while loading Financial Years');
        }
    }

    async getFinancialMonths(date, isInit) {
        this._switchIsBusyLoading(true);
        if (!date || date > this.today) {
            date = this.today;
        }

        try {
            await this.financialsServiceData.getFinancialMonths(this.selectedBuildingRef, date);
            let selectedMonthIndex = -1;

            const selectedDateMonth = this.FinancialsService.getSelectedMonth();

            if (selectedDateMonth) {
                const foundMonth = this.FinancialsService.financialMonths.find((month, index) => {
                    const momentMonth = moment(month.WhenFrom);
                    if (momentMonth.isSame(selectedDateMonth, 'month')) {
                        selectedMonthIndex = index;
                        return true;
                    }
                });

                if (selectedMonthIndex > -1 && foundMonth) {
                    this.filterMonth = this.FinancialsService.financialMonths[selectedMonthIndex].WhenFrom;
                }
            } else if (date && isInit) {
                this.financialsServiceData.financialMonths.filter((month, i) => {
                    const monthDateStr = month.WhenFrom.substr(0, 10);
                    const monthDate = moment(new Date(monthDateStr), 'YYYY-DD-MM');
                    const selectedMonth = this.FinancialsService.getSelectedMonth();

                    if (monthDate.isSame(selectedMonth, 'month')) {
                        selectedMonthIndex = i;
                        return true;
                    }
                });

                if (selectedMonthIndex === -1) {
                    this.filterMonth = '';
                    this._switchIsBusyLoading(false);
                } else {
                    this.filterMonth = this.financialsServiceData.financialMonths[selectedMonthIndex].WhenFrom;
                }
            } else if (isInit) {
                this.filterMonth = this.financialsServiceData.financialMonths[
                    this.financialsServiceData.financialMonths.length - 1
                ].WhenFrom;
            }
            if (this.filterMonth) {
                await this.getWagesRoll();
            }
        } catch (err) {
            console.error('Error while loading Financial Months', err);
        }
    }

    async getWagesRoll() {
        this._switchIsBusyLoading(true);
        this.selectedDate = this.FinancialsService.getSelectedDate(this.selectedDate);

        try {
            await this.WagesRollService.getWagesRoll(this.selectedBuildingRef, this.selectedDate);
            await this.getFinancialState();
        } catch (err) {
            console.error('Error while loading Wages Roll', err);
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    saveSelectedDate() {
        const selectedYear = moment(this.filterYear).toDate();
        const selectedMonth = moment(this.filterMonth).add(3, 'h').toDate();
        this.LocalStorageService.save('selectedReportYear', selectedYear);
        this.LocalStorageService.save('selectedReportMonth', selectedMonth);
    }

    async getSelectedDate(isInit) {
        const selectedDateYear = await this.FinancialsService.getSelectedYear();
        const selectedDateMonth = await this.FinancialsService.getSelectedMonth();

        if (isInit) {
            for (let i = 0; i < this.FinancialsService.financialYears.length; i++) {
                const yearRaw = this.FinancialsService.financialYears[i];

                const whenFrom = moment(yearRaw.WhenFrom).toDate();
                const whenTo = moment(yearRaw.WhenTo).toDate();

                if (selectedDateMonth >= whenFrom && selectedDateMonth <= whenTo) {
                    this.filterYear = this.FinancialsService.financialYears[i].WhenTo;
                    this.selectedDateYear = await this.Utility.getFormatedDate(this.filterYear);
                    break;
                }
            }

            const date = this.selectedDateYear ? this.selectedDateYear : new Date();
            await this.getFinancialMonths(date, true);
        }
    }

    async getFinancialState() {
        const type = 7;
        const schemeRef = this.selectedBuildingRef;
        const momentDate = moment(this.selectedDate, 'YYYY-MM-DD');
        const formattedDate = momentDate.format('YYYY-MM-DD');
        const date = `${formattedDate.substr(0, 8)}01`;

        this._switchIsBusyLoading(true);
        try {
            const results = await this.FinancialsService.getFinancialState(schemeRef, date, type);

            const { status, message } = results;
            this.statusInformation = message;
        } catch (error) {
            this.NotificationService.error('Error wages roll statement status');
        } finally {
            this._switchIsBusyLoading(false);
        }
    }

    allowAction(actionName) {
        return this.AuthorizationService.isAuthorized(actionName);
    }

    _switchIsBusyLoading(flag) {
        this.$timeout(() => {
            this.isLoading = flag;
        });
    }
}
